"use client";

import { useEffect } from "react";

import { reportGlobalRenderError } from "@/observability/report-error";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportGlobalRenderError(error);
  }, [error]);

  return (
    <html>
      <body className="bg-gray-50 text-gray-950">
        <div className="flex min-h-screen items-center justify-center px-6">
          <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm">
            <h1 className="mb-4 text-2xl font-semibold text-red-600">
              Something went wrong
            </h1>
            <p className="mb-6 text-sm text-gray-600">
              We logged this problem and you can try again safely.
            </p>
            <button
              type="button"
              onClick={reset}
              className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
